import React from "react";

const EnablingTawin = () => {
  return (
    <div>
      <section className="common-page-hero">
        <img
          src="assets/img/service/mw7.png"
          className="common-hero-bg ak-bg"
          alt="..."
        />
        <div className="common-hero-content">
          <div className="common-hero-info">
            <div className="ak-section-heading ak-style-1 animation-title-content animation-style3">
              <p
                className="ak-section-subtitle animation-title"
                style={{ perspective: "400px" }}
              >
                <div
                  className="split-line"
                  style={{
                    display: "block",
                    textAlign: "center",
                    position: "relative",
                  }}
                >
                  {"Courses".split("").map((char, index) => (
                    <div
                      key={index}
                      style={{
                        position: "relative",
                        display: "inline-block",
                        transform: "translate(0px, 0px)",
                        opacity: 1,
                      }}
                    >
                      {char}
                    </div>
                  ))}
                </div>
              </p>
              <br />
              <p
                className="mini-title1"
                style={{
                  backgroundColor: "rgb(232, 119, 34)",
                  color: "white",
                  padding: "5px 10px",
                  fontWeight: "bold",
                  display: "inline-block",
                  borderRadius: "5px",
                }}
              >
                SEMANTIC Skills Junction
              </p>
              <br />
              <h2
                className="ak-section-title animation-title"
                style={{ fontSize: "45px", perspective: "400px" }}
              >
                <div
                  className="split-line"
                  style={{
                    display: "block",
                    textAlign: "center",
                    position: "relative",
                  }}
                >
                  {"SEMANTIC Skills Junction: Bridging"
                    .split(" ")
                    .map((word, idx1) => (
                      <span
                        key={idx1}
                        style={{
                          position: "relative",
                          display: "inline-block",
                        }}
                      >
                        {word.split("").map((char, idx2) => (
                          <div
                            key={idx2}
                            style={{
                              position: "relative",
                              display: "inline-block",
                              transform: "translate(0px, 0px)",
                              opacity: 1,
                            }}
                          >
                            {char}
                          </div>
                        ))}
                        &nbsp;
                      </span>
                    ))}
                </div>
                <div
                  className="split-line"
                  style={{
                    display: "block",
                    textAlign: "center",
                    position: "relative",
                  }}
                >
                  {"Talent and Technology".split(" ").map((word, idx1) => (
                    <span
                      key={idx1}
                      style={{ position: "relative", display: "inline-block" }}
                    >
                      {word.split("").map((char, idx2) => (
                        <div
                          key={idx2}
                          style={{
                            position: "relative",
                            display: "inline-block",
                            transform: "translate(0px, 0px)",
                            opacity: 1,
                          }}
                        >
                          {char}
                        </div>
                      ))}
                      &nbsp;
                    </span>
                  ))}
                </div>
              </h2>
            </div>
            <p className="back-btn">
              <a href="/">Home</a> / Course
            </p>
          </div>
          <a href="tel:+917619617023" className="phone-number">
            (+91) 7619617023
          </a>
        </div>
      </section>

      <section>
        <div className="container" style={{ marginTop: "20px" }}>
          <div className="ak-section-heading ak-style-1 animation-title-content animation-style3">
            <h3
              className="ak-section-title animation-title"
              style={{
                fontSize: "37px",
                fontWeight: "bold",
                perspective: "400px",
              }}
            >
              <div
                className="split-line"
                style={{
                  display: "block",
                  textAlign: "start",
                  position: "relative",
                }}
              >
                {[
                  "ENABLING",
                  "TAIWAN",
                  "BASED",
                  "SUPPORT",
                  "TO",
                  "GROW",
                  "INDIA’S",
                ].map((word, index) => (
                  <div
                    key={index}
                    style={{ position: "relative", display: "inline-block" }}
                  >
                    {word.split("").map((char, i) => (
                      <div
                        key={i}
                        style={{
                          position: "relative",
                          display: "inline-block",
                          transform: "translate(0px, 0px)",
                          opacity: 1,
                        }}
                      >
                        {char}
                      </div>
                    ))}&nbsp;

                  </div>
                ))}
              </div>

              <div
                className="split-line"
                style={{
                  display: "block",
                  textAlign: "start",
                  position: "relative",
                }}
              >
                {["SEMICONDUCTOR,", "ESDM", "ECOSYSTEM"].map((word, index) => (
                  <div
                    key={index}
                    style={{ position: "relative", display: "inline-block" }}
                  >
                    {word.split("").map((char, i) => (
                      <div
                        key={i}
                        style={{
                          position: "relative",
                          display: "inline-block",
                          transform: "translate(0px, 0px)",
                          opacity: 1,
                        }}
                      >
                        {char}
                      </div>
                    ))}&nbsp;

                  </div>
                ))}
              </div>
            </h3>

            <p
              className="ak-section-desp"
              style={{ textAlign: "justify", fontSize: "18px" }}
            >
              Enabling Taiwan-based support can bolster India's semiconductor
              and ESDM ecosystem by fostering technological collaboration and
              knowledge transfer. Taiwan’s expertise in chip manufacturing and
              innovation can accelerate India’s ambitions to become a global
              electronics hub. This partnership can drive investments, create
              jobs, and strengthen supply chains in India.
            </p>
          </div>

          <div className="ak-height-50 ak-height-lg-30"></div>

          <div className="image-hov-one">
            <img
              className="img-fluid"
              src="assets/img/service/se.png"
              alt="..."
              style={{ marginRight: "20px" }}
            />
          </div>

          <p></p>
        </div>
      </section>
    </div>
  );
};

export default EnablingTawin;
